// extracted by mini-css-extract-plugin
export var a1 = "index-module--a1--0l6n2";